import { ButtonTypeTokens, } from '@voltmoney/schema';
import SharedPropsService from '../../../../SharedPropsService';
import { nextStepCredStepper } from '../../../../configs/utils';
import { api } from '../../../../configs/api';
import { getAppHeader } from '../../../../configs/config';
import AsyncStorage from "@react-native-async-storage/async-storage";
export const confirmPan = async (action, _datastore, { instrumentTrack, asyncStorage, goBack, setDatastore, navigate, navigateWithClear, network, ...props }) => {
    instrumentTrack("JOINT_HOLDER_VERIFY_PAN_BUTTON_CLICKED");
    const user = await SharedPropsService.getUser();
    await setDatastore(action.routeId, 'yesConfirmButton', {
        label: '',
        type: ButtonTypeTokens.LargeFilled,
        loading: true,
    });
    await network
        .post(api.verifyPanForCoBorrower, {
        applicationId: `${user.linkedApplications[0].applicationId}`,
        panNumber: `${action.payload.panNumber}`,
        dob: `${action.payload.dob}`,
        mobileNumber: `${action.payload.mobileNumber}`,
        emailId: `${action.payload.emailId}`,
    }, { headers: await getAppHeader() })
        .then(async (response) => {
        user.linkedApplications[0] = response.data.updatedApplicationObj;
        await SharedPropsService.setUser(user);
        let applicationId;
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
        let currentStepId;
        if (await AsyncStorage.getItem("application_id") !== null) {
            currentStepId = updatedApplicationResponse.data.currentStepId;
        }
        else {
            currentStepId = user.linkedApplications[0].currentStepId;
        }
        const routeObj = await nextStepCredStepper(currentStepId);
        await setDatastore(action.routeId, 'yesConfirmButton', {
            label: 'Continue',
            type: ButtonTypeTokens.LargeFilled,
            loading: false,
        });
        await goBack();
        await navigateWithClear(routeObj.routeId, routeObj.params);
    });
};
export const changePanNo = async (action, _datastore, { instrumentTrack, goBack }) => {
    instrumentTrack("JOINT_HOLDER_EDIT_PAN_BUTTON_CLICKED");
    goBack();
};
